import { ResponseProductAttribute } from '@/data/types/Product';
import { getProductAttribute } from './getProductAttribute';

export const EMPTY_PRODUCT_ATTRIBUTE = {} as ReturnType<typeof getProductAttribute>;

export const findProductAttribute = (
	attributes: ResponseProductAttribute[],
	identifier: string
) => {
	const _attributes = attributes || [];

	const responseProductAttribute = _attributes.find((attr) => attr.identifier === identifier);

	if (!responseProductAttribute) {
		return null;
	}

	const productAttribute = getProductAttribute(responseProductAttribute);

	return productAttribute;
};
